// extracted by mini-css-extract-plugin
export default {"l_TabMenuItem_main":"TabMenuItem_l_TabMenuItem_main__g-Duy","active":"TabMenuItem_active__UTBuE"};